import axios from 'axios';
import { bdmAppOrigin } from '../config/sfApiBase';

/** In dev, CRA proxy forwards /api/* to localhost:3001 (see package.json "proxy"). */
function getCeoApiBase() {
  if (process.env.NODE_ENV === 'development') {
    return '/api/ceo';
  }
  return `${bdmAppOrigin()}/api/ceo`;
}

function buildSummaryParams({ period, startDate, endDate } = {}) {
  if (startDate && endDate) {
    return { startDate, endDate };
  }
  return { period: period === 'MONTH' ? 'MONTH' : 'WEEK' };
}

/**
 * CEO dual-period Salesforce summary.
 * Uses global dashboard start/end dates when provided; otherwise rolling WEEK/MONTH windows.
 */
export async function fetchCeoSummary({ period, startDate, endDate } = {}) {
  const res = await axios.get(`${getCeoApiBase()}/summary`, {
    params: buildSummaryParams({ period, startDate, endDate }),
  });
  return res.data;
}

export async function fetchCeoWpNewProperties({ period, startDate, endDate } = {}) {
  const res = await axios.get(`${getCeoApiBase()}/wp-new-properties`, {
    params: buildSummaryParams({ period, startDate, endDate }),
  });
  return res.data;
}

export async function fetchCeoWpDelistings({ period, startDate, endDate } = {}) {
  const res = await axios.get(`${getCeoApiBase()}/wp-delistings`, {
    params: buildSummaryParams({ period, startDate, endDate }),
  });
  return res.data;
}

/** WordPress property posts: current FY YTD vs same period last FY (Jul 1 – Jun 30). */
export async function fetchCeoWpPropertyPostsFy() {
  const res = await axios.get(`${getCeoApiBase()}/wp-property-posts-fy`);
  return res.data;
}

export async function fetchCeoMetricDetail({ metric, period, window, stage, group, startDate, endDate }) {
  const res = await axios.get(`${getCeoApiBase()}/detail`, {
    params: {
      metric,
      ...(startDate && endDate
        ? { startDate, endDate }
        : { period: period === 'MONTH' ? 'MONTH' : 'WEEK' }),
      window: window === 'previous' ? 'previous' : 'current',
      ...(stage ? { stage } : {}),
      ...(group != null && group !== '' ? { group } : {}),
    },
  });
  return res.data;
}

export async function fetchCeoEnquiryPipeline() {
  const res = await axios.get(`${getCeoApiBase()}/enquiry-pipeline`);
  return res.data;
}
